import classNames from 'classnames'

import classes from './TwoButtonToggle.module.scss'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'


const TwoButtonToggle = ({ checked, onChange, name, disabled, checkedText, uncheckedText, defaultChecked = null }) => {
  const { t } = useTranslation()
  const isUncontrolled = !onChange || defaultChecked !== null
  const [checked_, setChecked_] = useState(!!defaultChecked)
  const checkedLabel = checkedText ?? t('common.twoButtonToggle.on')
  const uncheckedLabel = uncheckedText ?? t('common.twoButtonToggle.off')

  return (
    <div role='radiogroup' aria-labelledby='toggle' className={classNames(classes.wrapper, { [classes.disabled]: disabled })}>
      <button
        type='button'
        role='radio'
        aria-checked={isUncontrolled ? checked_ : checked}
        className={classNames(classes.roundButton, { [classes.active]: isUncontrolled ? checked_ : checked })}
        onClick={isUncontrolled ? (() => setChecked_(true)) : (() => onChange(true))}
      >
        {checkedLabel}
      </button>
      <button
        type='button'
        role='radio'
        aria-checked={isUncontrolled ? !checked_ : !checked}
        className={classNames(classes.roundButton, { [classes.active]: isUncontrolled ? !checked_ : !checked })}
        onClick={isUncontrolled ? (() => setChecked_(false)) : (() => onChange(false))}
      >
        {uncheckedLabel}
      </button>
      {isUncontrolled && (
        <input type='hidden' name={name} value={checked_} />
      )}
    </div>
  )
}

TwoButtonToggle.propTypes = {
  name: PropTypes.string,
  checkedText: PropTypes.string,
  uncheckedText: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  onChange: PropTypes.func,
}

export default TwoButtonToggle
